import Swiper from 'swiper/bundle';

var sliderContent = document.querySelector(".slider-banner-footer-container")

if (sliderContent) {
	new Swiper(sliderContent, {
        slidesPerView: 1,
        centeredSlides: true,
        fade: 'true',
        enabled: 'true',
        grabCursor: 'true',


        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },

        pagination: {
            el: ".banner-footer__pagination",
            dynamicBullets: false,
            clickable: true,
        },

        navigation: {
            nextEl: sliderContent.querySelector(".banner-footer__btn-next"),
            prevEl: sliderContent.querySelector(".banner-footer__btn-prev"),
        },

        breakpoints:{
            1024: {
                slidesPerView: 1,
            },
        },
    })
}
